import { Settings } from './settings';

export const STATE = 'USER';

export interface State {
  settings: Settings;
  canUseRestrictions: boolean;
}
